import { SignInWithEventCodePage } from '@/pages/sign-in-with-event-code';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/sign-in-with-event-code')({
  component: SignInWithEventCodePage,
});
